import { drupalComponent } from '@nech/src/helpers/drupal-component';

(function (Drupal, once, $) {
  drupalComponent('banner', {
    selector: '.nech--banner',
    shared: {},
    instance() {
      const $el = $(this.selector);
      const isTabletMobile = window.innerWidth < 1024;
      const $falcButton = $el.find('#nech--falc-button');
      const $falcModal = $('.nech--falc-modal');
      const $navMenuIcon = $('.nav--mobile-nav-items');
      const $globalSearch = $('.header-global-search');
      const $headerNavItems = $('.header--list-items');
      const $breadcrumb = $('#nech--breadcrumb');
      const $footer = $('footer');
      const $content = $('.nech--page-content');
      const $navItems = $('nav .top-link-nav-items');

      //404 403 page
      const $bannerContentWrapper = $el.find('.nech-banner--content');
      const $headingBanner = $el.find('.nech-banner--heading');

      if ($headingBanner.text() == '404' || $headingBanner.text() == '403') {
        $bannerContentWrapper.addClass('flex').css('align-items', 'baseline');
      }

      //falc
      $falcButton.on('click', function () {
        $el.attr('aria-hidden', 'true').hide();
        $globalSearch.attr('aria-hidden', 'true').hide();
        $breadcrumb.attr('aria-hidden', 'true').hide();
        $footer.attr('aria-hidden', 'true').hide();
        $content.attr('aria-hidden', 'true').hide();
        $falcModal.attr('aria-hidden', 'false').removeClass('hidden');
        $headerNavItems.attr('aria-hidden', 'true').hide();
        $navItems.attr('aria-hidden', 'true').hide();

        if (isTabletMobile) {
          $navMenuIcon.attr('aria-hidden', 'true').hide();
        }
      });
    },
  });
})(Drupal, once, jQuery);
